import { userRenamed } from 'features/users/actions';
import { call } from 'redux-saga/effects';
import { board } from 'utils/whiteboard/BoardStateManager';

export function* onUserRenamedSaga(action: ReturnType<typeof userRenamed>) {
  const { id, name } = action.payload;

  yield call(board.renamePointer, id, name);
}
